import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

const getJson = (str) => {
    try {
        return !!str && JSON.parse(str);
    }
    catch (e) {
        return null;
    }
};
class NotificationService {
    constructor(notificationApiUrl) {
        this.getNotification = async (params) => {
            var _a;
            const { data } = await this.notificationApi.get(`/notifications`, {
                params,
            });
            const formattedNotis = ((_a = data.data.notifications) === null || _a === void 0 ? void 0 : _a.map((noti) => {
                var _a;
                const parsedLink = getJson(noti.link);
                const link = parsedLink ? parsedLink : '';
                if (link && ['order', 'noti'].includes(link.type)) {
                    return Object.assign(Object.assign({}, noti), { order: link.type === 'order' ? link === null || link === void 0 ? void 0 : link.data : null, deepLink: link.type === 'noti' ? (_a = link === null || link === void 0 ? void 0 : link.data) === null || _a === void 0 ? void 0 : _a.deeplink : null });
                }
            }).filter((noti) => !!noti)) || [];
            return Object.assign(Object.assign({}, data.data), { notifications: formattedNotis });
        };
        this.markNotificationAsRead = async (notificationId, token) => {
            const { data } = await this.notificationApi.put(`/notification/${notificationId}/mark-read`, {
                token,
            });
            return data;
        };
        this.unreadCount = async (params) => {
            const { data } = await this.notificationApi.get('/notification/count-unread', {
                params,
            });
            return data === null || data === void 0 ? void 0 : data.data;
        };
        this.registerToken = async (params) => {
            await this.notificationApi.post('notification/register-token', params);
        };
        this.unRegisterToken = async (params) => {
            await this.notificationApi.post('notification/unregister-token', params);
        };
        this.notificationApi = new Api(notificationApiUrl);
        this.notificationApi.addInterceptor(accessTokenInterceptor);
    }
}

export { NotificationService };
